import { Component, HostListener, OnInit} from '@angular/core';
import { FormControl } from '@angular/forms';
import { NavigationEnd, Event, NavigationError, Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
    selector: 'app-language-drop-down',
    templateUrl: './language-drop-down.component.html',
    styleUrls: ['./language-drop-down.component.scss'],
    standalone: false
})
export class LanguageDropDownComponent implements OnInit {
  selectedLanguage = new FormControl();
  languages: languageList[] = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español'},
    { code: 'fr', label: 'Français' },
  ];
  showLanguageDropdown = false;
  isMenuOpen = false
  isMobileScreen = this.breakpointObserver.isMatched('(max-width: 720px)');
  

  constructor(private readonly router: Router,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (this.router.url != "/") {
          if (this.router.url === '/registration' || this.router.url === '/home' || this.router.url === '/welcome') {
            this.selectedLanguage.disable()
            this.showLanguageDropdown = false
          }
          else {
            this.selectedLanguage.disable()
            this.showLanguageDropdown = false
          }
        }
      }
      if (event instanceof NavigationError) {
        console.error(event.error);
      }
    });
  }

  
  ngOnInit() {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width: 720px)');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width: 720px)');
  }
  
  onLanguageChange(languageSelected: string) {
    location.replace("/" + languageSelected + this.router.url);
  }

  menuOpened() {
    this.isMenuOpen = true
  }

  menuClosed(){
    this.isMenuOpen =false
  }
}

export interface languageList {
  code: string;
  label: string;
}
